import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebb4b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Indietro", -1))
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "name text-input col-span-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome cantiere", -1))
const _hoisted_6 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_7 = { class: "address text-input" }
const _hoisted_8 = { for: "address" }
const _hoisted_9 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_10 = { class: "customer text-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer" }, "Cliente (opzionale)", -1))
const _hoisted_12 = { class: "order-number text-input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "order-number" }, "Ordine (opzionale)", -1))
const _hoisted_14 = { class: "date text-input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start-date" }, "Data inizio", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_18 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_19 = { class: "date text-input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "Data fine (opzionale)", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_23 = { class: "link text-input" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "link" }, "Link a Cruise Mapper", -1))
const _hoisted_25 = { class: "is-special text-input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is-special" }, "Cantiere speciale", -1))
const _hoisted_27 = {
  key: 1,
  class: "content overflow-hidden"
}
const _hoisted_28 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_29 = { class: "left-content" }
const _hoisted_30 = { class: "searchbar flex" }
const _hoisted_31 = { class: "user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_32 = { class: "working-site-name font-bold" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "right-content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-description-voices grid grid-cols-3 gap-4 py-3 mt-3 pl-3 pr-6" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Dipendente"),
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Capocantiere"),
  /*#__PURE__*/_createElementVNode("div", { class: "delete" })
], -1))
const _hoisted_36 = { class: "added-user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_37 = { class: "working-site-name font-bold" }
const _hoisted_38 = { class: "chief-checkbox text-center container" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 2,
  class: "content"
}
const _hoisted_41 = { class: "content-success text-center m-auto items-center mt-20" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "font-bold" }, [
  /*#__PURE__*/_createTextVNode("La creazione del cantiere è avvenuta"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("con successo!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SuccessIcon = _resolveComponent("SuccessIcon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, { class: "add-new-working-site-modal-dialog" }, {
    h4: _withCtx(() => [
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "go-back flex absolute",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onStep1 && _ctx.onStep1(...args)))
          }, [
            _createVNode(_component_LeftArrow),
            _hoisted_1
          ]))
        : _createCommentVNode("", true)
    ]),
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
    ]),
    h2: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
    ]),
    h3: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.steps), 1)
    ]),
    buttons: _withCtx(() => [
      (_ctx.step != 2)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 0,
            class: "button bg-white text-primary-900 undo",
            onClick: _ctx.onClose
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.step == 0 && !_ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 1,
            class: "button bg-primary-900 text-white",
            onClick: _ctx.onStep2
          }, {
            default: _withCtx(() => [
              _createTextVNode("Avanti")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.step == 0 && _ctx.isEditing)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 2,
            class: "button bg-primary-900 text-white",
            onClick: _ctx.update
          }, {
            default: _withCtx(() => [
              _createTextVNode("Aggiorna")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 3,
            class: "button bg-primary-900 text-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.create()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Crea")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createBlock(_component_PrimaryButton, {
            key: 4,
            class: "button bg-primary-900 text-white m-auto text-center",
            onClick: _ctx.onClose
          }, {
            default: _withCtx(() => [
              _createTextVNode("Prosegui")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.step == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.step1.name.$error }]),
                  id: "name",
                  type: "text",
                  placeholder: "Inserisci il nome del cantiere",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.name) = $event)),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.name.$touch && _ctx.v$.step1.name.$touch(...args)))
                }, null, 34), [
                  [_vModelText, _ctx.step1.name]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È necessario inserire il nome del cantiere."))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode("Indirizzo o Porto d’imbarco"),
                  _createVNode(_component_GMapAutocomplete, {
                    class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.step1.address.$error, 'placeholder-as-text': _ctx.wsaPlaceholderIsAddress }]),
                    id: "address",
                    placeholder: _ctx.workingSiteAddressPlaceholder,
                    onBlur: _ctx.v$.step1.address.$touch,
                    onPlace_changed: _ctx.onGmapAutocompleteAddress
                  }, null, 8, ["placeholder", "onBlur", "onPlace_changed", "class"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "hidden",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.address) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.step1.address]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.address.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_9, "È necessario selezionare l'indirizzo del Porto d'imbarco"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-primary-50 border-red-400",
                  id: "customer",
                  type: "text",
                  placeholder: "Inserisci il nome del cliente",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.customer) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.step1.customer]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-primary-50 border-red-400",
                  id: "order-number",
                  type: "text",
                  placeholder: "Inserisci il numero d'ordine",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.orderNumber) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.step1.orderNumber]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.step1.startDate,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.startDate) = $event)),
                  mode: "date",
                  "input-debounce": 500
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createElementVNode("input", _mergeProps({
                      class: "bg-primary-50 border-red-400",
                      id: "start-date",
                      type: "text",
                      placeholder: "gg/mm/aaaa",
                      value: inputValue
                    }, _toHandlers(inputEvents, true), {
                      class: { border: _ctx.v$.step1.startDate.$error },
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.startDate.$touch && _ctx.v$.step1.startDate.$touch(...args)))
                    }), null, 16, _hoisted_16)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.startDate.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_17, "È necessario inserire la data di inizio cantiere"))
                      : _createCommentVNode("", true),
                    (error.$validator == 'dateValidator')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, "La data inserita non è valida"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.step1.endDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step1.endDate) = $event)),
                  mode: "date",
                  "input-debounce": 500
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createElementVNode("input", _mergeProps({
                      class: "bg-primary-50 border-red-400",
                      id: "end-date",
                      type: "text",
                      placeholder: "gg/mm/aaaa",
                      value: inputValue
                    }, _toHandlers(inputEvents, true)), null, 16, _hoisted_21)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.endDate.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'dateValidator')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_22, "La data inserita non è valida"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  class: "bg-primary-50 border-red-400",
                  id: "link",
                  type: "text",
                  placeholder: "Inserisci link da Cruise Mapper",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.step1.link) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.step1.link]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Toggle, {
                  class: "inline-block self-center",
                  id: "is-special",
                  modelValue: _ctx.step1.isSpecialWorkingSite,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step1.isSpecialWorkingSite) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    class: "text px-4 py-3 flex-grow user-filter-input",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.usersSearchFilter) = $event)),
                    type: "text",
                    placeholder: "Inserisci il nome del dipendente"
                  }, null, 512), [
                    [_vModelText, _ctx.usersSearchFilter]
                  ]),
                  _createElementVNode("button", {
                    class: "button text-primary flex-none font-bold find",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.searchUsers()))
                  }, "Cerca")
                ]),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unselectedUsers, (unselectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user",
                      key: unselectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_32, _toDisplayString(unselectedUser.name) + " " + _toDisplayString(unselectedUser.surname), 1),
                      _createElementVNode("button", {
                        class: "add-working-site font-bold",
                        onClick: ($event: any) => (_ctx.addUser(unselectedUser.id))
                      }, "Aggiungi", 8, _hoisted_33)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (selectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user grid grid-cols-3",
                      key: selectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(selectedUser.name) + " " + _toDisplayString(selectedUser.surname), 1),
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_Checkbox, {
                          class: "m-auto checkbox",
                          "model-value": _ctx.isForeman(selectedUser.id),
                          "onUpdate:modelValue": ($event: any) => (_ctx.toggleForman(selectedUser.id))
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("button", {
                        class: "remove-WorkingSite font-bold",
                        onClick: ($event: any) => (_ctx.removeUser(selectedUser.id))
                      }, "Elimina", 8, _hoisted_39)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_SuccessIcon, { class: "mx-auto mb-12" }),
              _hoisted_42
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 3,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}